























































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { IAppOrder } from '@/apps/open/types/app'
import { getVasList } from '@/apps/open/services/vasopen'
import { onRequestError } from '@/apps/open/utils'

const MAX_LENGTH = 6

@Component
export default class AppOrder extends Vue {
  loading = false
  form: any = {
    billno: '',
    status: '',
    ctime: [moment().subtract(1, 'month'), moment()],
    ftime: [],
    category: '',
    subject: ''
  }
  orderList: IAppOrder[] = []
  total = 0
  total_fee = 0
  totalPage = 0
  currentPage = 1
  pageSize = 10
  selectDate = ''
  statusOptions = [{
    label: '不限',
    value: 'unlimited'

  }, {
    label: '未支付',
    value: 'unpay'
  }, {
    label: '已完成',
    value: 'finish'
  }]
  categoryOptions = [{
    label: '不限',
    value: 'unlimited'
  }, {
    label: '会员',
    value: 'member'
  }, {
    label: '零售',
    value: 'retail'
  }]
  searchParams: any = {}

  cTimePickerOptions = {
    onPick: (dateRange: any) => {
      this.selectDate = dateRange.minDate
      if (dateRange.maxDate) {
        this.selectDate = ''
      }
    },
    disabledDate: (time: Date) => {
      let start = moment(this.selectDate).add(1, 'month')
      let end = moment(this.selectDate).subtract(1, 'month')
      return moment(time) > moment() || moment(time) > start || moment(time) < end
    }
  }

  columns = [
    {
      prop: 'billno',
      label: '订单编号',
      minWidth: 180
    },
    {
      prop: 'category',
      label: '订单类别',
      minWidth: 80
    },
    {
      prop: 'subject',
      label: '订单内容',
      minWidth: 180
    },
    {
      prop: 'count',
      label: '订单数量',
      minWidth: 100,
      formatter: (row: any) => {
        return `x${row.count}`
      }
    },
    {
      prop: 'total_fee',
      label: '订单金额',
      minWidth: 130,
      formatter: (row: any) => {
        return this.formatNum(row.total_fee)
      }
    },
    {
      prop: 'status',
      label: '订单状态',
      minWidth: 90,
      formatter: (row: any) => {
        return this.getStatus(row.status)
      }
    },
    {
      prop: 'ctime',
      label: '创建时间',
      minWidth: 100,
      formatter: (row: any) => {
        return this.getTime(row.ctime)
      }
    },
    {
      prop: 'finish_time',
      label: '完成时间',
      minWidth: 100,
      formatter: (row: any) => {
        return this.getTime(row.finish_time)
      }
    }
  ]

  get id () {
    return this.$route.params['id']
  }
  get fileName () {
    let now = moment().format('YYYYMMDDHHmmss')
    return now
  }

  get disabledExport () {
    return !this.total || this.loading
  }

  created () {
    this.load()
  }

  getTime (time: any) {
    return time ? moment(time * 1000).format('YYYY-MM-DD HH:mm:ss') : '-'
  }

  getStatus (status: string) {
    if (status) {
      const statusItem = this.statusOptions.find((t: any) => t.value === status) as any
      return statusItem.label
    }
    return ''
  }

  formatNum (num:any) {
    let formatNum = Math.round(parseFloat(num)) / 100
    let numArr = formatNum.toString().split('.')
    let newNum
    if (numArr.length === 1) {
      newNum = `￥${formatNum.toString()}.00`
      return newNum
    }
    if (numArr.length > 1) {
      numArr[1].length < 2 ? newNum = `￥${formatNum.toString()}0` : newNum = `￥${formatNum.toString()}`
      return newNum
    }
  }

  subFormat (row:string) {
    const text = row
    const hasMore = text.length > MAX_LENGTH
    return `${text.slice(0, MAX_LENGTH)}${hasMore ? '...' : ''}`
  }

  getParams () {
    const params: any = {}
    for (let key in this.form) {
      const value = this.form[key]
      if (value) {
        if (key === 'ctime' && value.length) {
          params['ctime_start'] = Math.round(moment(value[0]).startOf('day').hours(0).valueOf() / 1000)
          params['ctime_end'] = Math.round(moment(value[1]).endOf('day').valueOf() / 1000)
        } else if (key === 'ftime' && value.length) {
          params['ftime_start'] = Math.round(moment(value[0]).startOf('day').hours(0).valueOf() / 1000)
          params['ftime_end'] = Math.round(moment(value[1]).endOf('day').valueOf() / 1000)
        } else if (key === 'status' && value === 'unlimited') {
          params[key] = ''
        } else if (key === 'category' && value === 'unlimited') {
          params[key] = ''
        } else {
          params[key] = value
        }
      }
    }
    return {
      ...params,
      limit: this.pageSize,
      offset: (this.currentPage - 1) * this.pageSize
    }
  }

  async load () {
    this.loading = true
    const params = this.getParams()
    try {
      const resp = await getVasList(this.id, params)
      this.orderList = resp.data.list.data
      this.total = resp.data.list.total
      this.total_fee = resp.data.list.total_fee
      this.totalPage = Math.ceil(this.total / this.pageSize)
      this.searchParams = params
    } catch (error) {
      onRequestError(error)
    }
    this.loading = false
  }

  changePage (page: number) {
    this.currentPage = page
    this.load()
  }

  search () {
    this.currentPage = 1
    this.load()
  }

  reset () {
    (this.$refs['searchForm'] as any).resetFields()
  }

  async exportTable () {
    const params = { ...this.searchParams, is_export: 1 }
    let iMsg
    try {
      const resp = await getVasList(this.id, params)
      iMsg = this.$message.success('订单导出中，请耐心稍等')
      this.exportCsv(resp.data.list.data, `订单数据 ${this.fileName}.csv`)
    } catch (error) {
      iMsg && iMsg.close()
      this.$message.error('当前网络异常，请稍后重试')
    }
  }

  exportCsv (content:any, filename:string) {
    let str = `订单编号,订单内容,订单状态,位置标识,创建时间,完成时间,订单数量,订单金额,订单类别\n`
    const ignoreItems = ['service_id', 'openid']
    for (let i = 0; i < content.length; i++) {
      for (let item in content[i]) {
        if (ignoreItems.includes(item)) {
          continue
        } else if (item === 'status') {
          content[i][item] === 'unpay' ? Vue.set(content[i], 'status', '未支付') : Vue.set(content[i], 'status', '已完成')
        } else if (item === 'ctime') {
          const ctime = content[i][item]
          const formatTime = moment(ctime * 1000).format('YYYY-MM-DD HH:mm:ss')
          content[i][item] ? Vue.set(content[i], 'ctime', formatTime) : Vue.set(content[i], 'ctime', '-')
        } else if (item === 'finish_time') {
          const ftime = content[i][item]
          const formatTime = moment(ftime * 1000).format('YYYY-MM-DD HH:mm:ss')
          content[i][item] ? Vue.set(content[i], 'finish_time', formatTime) : Vue.set(content[i], 'finish_time', '-')
        }
        str += `${content[i][item]},`
      }
      str += '\n'
    }
    let uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
    var $a = document.createElement('a')
    $a.href = uri
    $a.download = filename
    $a.target = '_blank'
    $a.click()
    return $a
  }
}
